import * as Yup from 'yup';

import { i18nTranslationsHandler } from '../../utils/scopedTranslator';
const t = i18nTranslationsHandler();

export const formFieldsSpecification = {
  newPassword: Yup.string().required(t('validationSchema.newPasswordRequired')),
};

export const SetPasswordValidationSchema = Yup.object().shape(
  formFieldsSpecification,
);
